module.exports = __webpack_public_path__ + "static/media/snowy.b8f02aa3.svg";